import * as types from './action-types'

export const fetchVenueCategories = (employerID: number) => ({
  type: types.VENUE_CATEGORIES_FETCH_BEGIN,
  employerID,
})
